// RichText.js
import React from 'react';
import DOMPurify from 'dompurify';

const purifyConfig = {
  FORCE_BODY: true,
  USE_PROFILES: { html: true },
};


const RichText = ({ richText = ''}) => {
  const sanitizedRichText = DOMPurify.sanitize(richText, purifyConfig);

  return (
    <div className="l-grid l-grid--max-width">
      <div className="l-grid__row">
          <div className="l-grid__column-12"
              dangerouslySetInnerHTML={{ __html: sanitizedRichText }}>
          </div>
      </div>
  </div>
  )
};

export default RichText;